import { useQuery } from '@tanstack/react-query'

import { CAR_STORY_QUERY_KEYS } from '../../lib/queryKeys'
import { getCarStoryHome } from '../request/carStoryApis'

const useCarStoryHomeQuery = () =>
  useQuery({
    queryKey: CAR_STORY_QUERY_KEYS.HOME.all,
    queryFn: getCarStoryHome,
    throwOnError: false,
    // prefetch 초기 데이터를 마운트 시 재요청 안 하도록 fresh 유지
    staleTime: Infinity,
  })

export default useCarStoryHomeQuery
